import React, { useState , useEffect} from "react";
import TopBar from "./../../components/TopBar";
import "./../css/Alert.css"; // Import custom CSS
import axios from "./../../axios";
import { Download } from "lucide-react";
import { linkify } from "./../../utils/linkify";
const StaffAlert = () => {
     const [alerts,setAlert] = useState([
    {
      
      details: "No Alert Found",
      file: "",
      
    },
     
  ]);
    const [isLoading, setIsLoading] = useState(true);
  
    useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const staff = JSON.parse(localStorage.getItem("staff")); // or pass from props/context

      const response = await axios.get('staff/alerts', {
        params: {
          id: staff.id// ✅ clean header
        },
      });
 
      console.log(response.data);
      setAlert(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }finally{
      setIsLoading(false);
    }
  };

  fetchData();
}, []);
 

  return (
    <>
    
      <TopBar title="Alerts" />
      
    {isLoading?(
      <>
<div className="alerts-container">
          <div className="calendar-skeleton">

        {[...Array(4)].map((_,i) => (
          <div key={i} className="alert-card skeleton-box">
            <h2 className="alert-title skeleton-text" style={{ width: '30%'}}></h2>
            <p className="alert-message skeleton-text" style={{ width: '50%', height:'50px'}}></p>
            <p className="alert-time skeleton-text" style={{ width: '10%'}}></p>
          </div>
        ))}
      </div>
      </div>
      </>
    ):(
      <>
      <div className="alerts-container">
        {alerts.map((alert) => (
          <div key={alert.id} className="alert-card">
            <h2 className="alert-title">{alert.title}</h2>
            <p className="alert-message">{linkify(alert.details)}</p>
            {alert.file && (
              <div className="alert-file">
                <a
                  href={`https://new.proschoolerp.com/${alert.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn"
                >
                  <Download size={16} />
                  Download Attachment
                </a>
              </div>
            )}
            <p className="alert-time">{alert.time}</p>
          </div>
        ))}
      </div>
      </>
    )}
      
    </>
  );
};

export default StaffAlert;